export default {
  'department.department': 'قسم',
  'department.name': 'اسم القسم',
  'department.perisanname': 'اسم القسم باللغة الفارسية',
  'department.englishname': 'اسم القسم باللغة الإنجليزية',
  'department.code': 'كود القسم',
  'department.add': 'إضافة قسم',
  'department.title': 'إدارة الأقسام',
  'department.departmentdel': 'حذف القسم',
  'department.departmentadd': 'تمت إضافة القسم بنجاح!',
  'department.departmentdelete': 'تم حذف القسم بنجاح!',
  'department.deleteerror': 'السجل تم استخدامه بواسطة سجلات أخرى',
  'department.departmentaddInformation': 'تم تعديل معلوماتك بنجاح',
};
